import { useId } from 'react';
import {
  CHAMPAGNE,
  CoreDisc,
  CoreMood,
  CoreRim,
  CoreRoot,
  CoreSheen,
  CoreStar,
  CoreTwinkle,
  GOLD,
  GOLD_RICH,
  GOLD_SOFT,
} from './core.styles';

/** A four-point sparkle with curved flanks, on a 24-unit box. */
const SPARKLE =
  'M12 1.5C12.9 7.4 16.6 11.1 22.5 12C16.6 12.9 12.9 16.6 12 22.5C11.1 16.6 7.4 12.9 1.5 12C7.4 11.1 11.1 7.4 12 1.5Z';

interface AiCoreProps {
  size?: number;
  mood?: CoreMood;
  /** The small companion sparkles; off where the core is too small for them. */
  sparks?: boolean;
}

/** The assistant's mark: a gold AI sparkle on the brand navy, ringed in gold. */
const AiCore = ({ size = 56, mood = 'idle', sparks = true }: AiCoreProps) => {
  // Several cores are on screen at once; each needs its own gradient id.
  const gradient = `ai-core-gold-${useId().replace(/:/g, '')}`;
  return (
    <CoreRoot size={size} mood={mood} aria-hidden>
      <CoreRim size={size} mood={mood} />
      <CoreDisc>
        <CoreSheen />
        <CoreStar viewBox="0 0 24 24" mood={mood}>
          <defs>
            <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor={CHAMPAGNE} />
              <stop offset="45%" stopColor={GOLD_SOFT} />
              <stop offset="75%" stopColor={GOLD} />
              <stop offset="100%" stopColor={GOLD_RICH} />
            </linearGradient>
          </defs>
          <path d={SPARKLE} fill={`url(#${gradient})`} />
        </CoreStar>
        {sparks && (
          <>
            <CoreTwinkle
              viewBox="0 0 24 24"
              delay={0}
              scale={22}
              sx={{ top: '14%', right: '16%' }}
            >
              <path d={SPARKLE} fill={CHAMPAGNE} />
            </CoreTwinkle>
            <CoreTwinkle
              viewBox="0 0 24 24"
              delay={1.4}
              scale={14}
              sx={{ bottom: '20%', left: '18%' }}
            >
              <path d={SPARKLE} fill={GOLD_SOFT} />
            </CoreTwinkle>
          </>
        )}
      </CoreDisc>
    </CoreRoot>
  );
};

export default AiCore;
